/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

import { SpinnerIcon } from '@coursera/cds-icons';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const styles = {
  loadingSpinnerCenteredContainer: css`
    position: relative;
    width: 100%;
    height: 100%;
  `,
  spinnerIconCentered: css`
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  `,
  spinnerIconAnimated: css`
    animation: ${rotate} 2s infinite linear;
  `,
};

/**
 * Renders loading spinner.
 * It was implemented before CDS version was available.
 *
 * @deprecated Use CDS `LoadingSection` or `LoadingIcon`
 * @param { centered?: boolean }
 * @returns React.JSX.Element
 */
const LoadingSpinner = ({ centered = false }: { centered?: boolean }) => {
  const spinnerIcon = (
    <SpinnerIcon
      css={[styles.spinnerIconAnimated, centered && styles.spinnerIconCentered]}
      title="Loading"
      size="large"
    />
  );
  return centered ? <div css={styles.loadingSpinnerCenteredContainer}>{spinnerIcon}</div> : spinnerIcon;
};

export default LoadingSpinner;
